import React from 'react';
import styled from 'styled-components';
import { Stars } from '@catalogo/theme-stars';
import { Wrapper } from '@catalogo/theme-wrapper';
import Button from '@catalogo/ui-americanas-desktop-button';

const NoReviews = ({ productId }) => (
  <Container>
    <NoReviewsWrapper>
      <div>
        <Stars rating={0} size={36} />
        <TextNoReviews>
          Ajude outras pessoas,
          <br />
          <span>faça a primeira avaliação desse produto ;)</span>
        </TextNoReviews>
      </div>
      <ButtonUI
        href={`/avaliacao/${productId}`}
        width="200px"
        height="45px"
        title="Avaliar produto"
        borderRadius="8px"
        fontSize="16px"
        fontWeight="normal"
      />
    </NoReviewsWrapper>
  </Container>
);

export default NoReviews;

const Container = styled(Wrapper)`
  margin-bottom: 0px;
`;

const NoReviewsWrapper = styled.div`
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextNoReviews = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  font-size: 18px;
  margin-top: 20px;
  span {
    font-size: 20px;
    font-weight: 700;
  }
`;

const ButtonUI = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
